<app-customer-account-dialog>
  <div id="content">
    <div class="overlay filterData filterDataControls">

      <div class="overlay-header">
        <h3>Filters</h3>
        <div class="close-btn">
          <button mat-icon-button mat-dialog-close (click)="closeFilter()">
            <i class="fa-sharp fa-regular fa-xmark-large"></i>
          </button>
        </div>
      </div>
      <div class="section-divider"></div>
      <form id="filterForm" class="form-scroll">
        <div class="overlay-body">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <h3>Date Range</h3>
              </div>
            </div>
            <div class="row border-bottom" [formGroup]="range">
              <div class="col-md-6 flex">
                <mat-form-field appearance="fill" class="component-box">
                  <mat-label>Date From (MMM-DD-YYYY)</mat-label>
                  <input matInput [matDatepicker]="picker1" [max]="maxDate" formControlName="start"
                    (dateChange)="addEvent( $event)">
                  <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance="fill" class="component-box">
                  <mat-label>Date To (MMM-DD-YYYY)</mat-label>
                  <input matInput [matDatepicker]="picker2" [min]="minDate" [max]="maxDate" formControlName="end">
                  <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">

                <h3>Created By <span> (Max. 3 user per search)</span> </h3>
                <mat-form-field appearance="fill" class="component-box chips">
                  <mat-label>Type client name here. E.g. Michaelangelo A</mat-label>
                  <mat-chip-list #chipList1 aria-label="Topic selection">
                    <mat-chip *ngFor="let topic of selectedTopics" (removed)="removeTopic(topic)">
                      {{topic}}
                      <button matChipRemove>
                        <f-icon [iconConfig]="iconConfig"></f-icon>
                      </button>
                    </mat-chip>

                    <input placeholder="" #topicInput [formControl]="topicValue" [matAutocomplete]="auto1"
                      [matChipInputFor]="chipList1" (matChipInputTokenEnd)="addTopic($event)">
                  </mat-chip-list>
                  <mat-autocomplete #auto1="matAutocomplete" (optionSelected)="selectedTopic($event)">
                    <mat-option *ngFor="let topic of filteredTopic | async" [value]="topic" class="truncate">
                      {{topic}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

                <p class="error">Only 3 users can be selected.</p>
              </div>
            </div>
            <!-- Commenting out the Topic Autochip component, and should be uncommented by Features when in use. -->
            <div class="row section-divider "></div>
            <div class="row">
              <div class="col-md-12">

                <h3>Title <span> (Max. 3 title per search)</span> </h3>
                <mat-form-field appearance="fill" class="component-box chips">
                  <mat-label>Type topics here. e.g. Health related</mat-label>
                  <mat-chip-list #chipList2 aria-label="Title selection">
                    <mat-chip *ngFor="let title of selectedTitles" (removed)="removeTitle(title)">
                      {{title}}
                      <button matChipRemove>
                        <f-icon [iconConfig]="iconConfig"></f-icon>
                      </button>
                    </mat-chip>

                    <input placeholder="" #titleInput [formControl]="titleValue" [matAutocomplete]="auto2"
                      [matChipInputFor]="chipList2" (matChipInputTokenEnd)="addTitle($event)">
                  </mat-chip-list>
                  <mat-autocomplete #auto2="matAutocomplete" (optionSelected)="selectedTitle($event)">
                    <mat-option *ngFor="let title of filteredTitle | async" [value]="title" class="truncate">
                      {{title}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

                <p class="error">Only 3 title can be selected.</p>
              </div>
            </div>
            <div class="row section-divider"></div>
            <div class="row">
              <div class="col-md-12">

                <h3>Description <span> (Max. 3 descriptions per search)</span> </h3>
                <mat-form-field appearance="fill" class="component-box chips">
                  <mat-label>Type topics here. E.g. Health related</mat-label>
                  <mat-chip-list #chipList3 aria-label="Topic selection">
                    <mat-chip *ngFor="let description of selectedDescriptions"
                      (removed)="removeDescription(description)">
                      {{description}}
                      <button matChipRemove>
                        <f-icon [iconConfig]="iconConfig"></f-icon>
                      </button>
                    </mat-chip>

                    <input placeholder="" #descriptionInput [formControl]="descriptionValue" [matAutocomplete]="auto3"
                      [matChipInputFor]="chipList3" (matChipInputTokenEnd)="addDescription($event)">
                  </mat-chip-list>
                  <mat-autocomplete #auto3="matAutocomplete" (optionSelected)="selectedDescription($event)">
                    <mat-option *ngFor="let description of filteredDescription | async" [value]="description"
                      class="truncate">
                      {{description}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

                <p class="error">Only 3 descriptions can be selected.</p>
              </div>
            </div>
            <div class="row section-divider"></div>
          </div>
        </div>
      </form>
      <div class="button-controls">

        <f-button text="Clear all" type="button" variant="action"></f-button>
        <f-button text="Apply" type="button" variant="progressive"></f-button>
      </div>



    </div>
  </div>
</app-customer-account-dialog>